import React from "react";
import Accordion from "react-bootstrap/Accordion";

/*eslint-disable */

interface AccordionComponentProps {
  politicas: any;
}

declare const window: any;
const AccordionComponent: React.FC<AccordionComponentProps> = ({
  politicas,
}) => {
  return (
    <div className="accordion-politicas-component">
      <Accordion defaultActiveKey="0">
        {politicas?.terms?.map((item: any, index: number) => (
          <Accordion.Item eventKey={`${index}`}>
            <Accordion.Header>{item?.title}</Accordion.Header>
            <Accordion.Body
              dangerouslySetInnerHTML={{ __html: item?.description }}
            ></Accordion.Body>
          </Accordion.Item>
        ))}
      </Accordion>
    </div>
  );
};

export default AccordionComponent;
